module.exports = __webpack_public_path__ + "static/logo-b602bf185350ea6b45e9ef2d16eef104.png";